export const iconFontAwesomeDesignHighlighter = (
	<i className="fa-solid fa-highlighter"></i>
);
